import Cookies from 'js-cookie'
import { useCallback, useEffect, useState } from 'react'

const COOKIE_NAME = 'cookie_accepted'
const COOKIE_EXPIRY_DAYS = 90 // 3 месяца

/**
 * Хук для управления показом плашки принятия cookie
 *
 * Логика:
 * - Показываем плашку при первом заходе (если нет куки с принятием)
 * - После принятия сохраняем куку и скрываем плашку
 */
export const useCookieAcceptation = () => {
	const [isVisible, setIsVisible] = useState(false)

	// Проверяем, нужно ли показывать плашку
	useEffect(() => {
		const hasAccepted = Cookies.get(COOKIE_NAME)
		setIsVisible(!hasAccepted)
	}, [])

	// Обработчик принятия cookie
	const handleAccept = useCallback(() => {
		Cookies.set(COOKIE_NAME, 'true', {
			expires: COOKIE_EXPIRY_DAYS,
			path: '/',
			domain: '.iport.ru'
		})

		setIsVisible(false)
	}, [])

	return {
		isVisible,
		handleAccept
	}
}
